const LayoutV2HelpCenter: React.FunctionComponent = function () {
  return (
    <div className="p-4 md:px-6 bg-neutral-000 flex flex-col gap-y-3 border border-neutral-300 rounded-xl w-full max-w-3xl mx-auto">
      <h2 className="text-18-22-em">Still have questions?</h2>
      <h3 className="text-14-22 text-neutral-700">
        Click the <b>Need Help</b> button in the header to get our contact
        information.
      </h3>
    </div>
  );
};

export default LayoutV2HelpCenter;
